<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger
} from '~/components/ui/dialog'
import { Button } from '~/components/ui/button'

const route = useRoute()
const isOpen = ref(false)
const { cardInstructionsComponent } = useCardInstructionsComponent(route.params.bank as string)
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger as-child>
      <Button variant="blue" class="w-full">
        <i class="[&>svg]:size-5"><UiIcon name="cards_supported" /></i>
        {{ $t('widget.card_instructions_modal.open_card') }}
      </Button>
    </DialogTrigger>
    <DialogContent class="max-h-screen max-w-6xl overflow-y-auto p-0 pt-6 sm:p-0">
      <DialogTitle class="sr-only">{{
        $t('widget.card_instructions_modal.dialog_title')
      }}</DialogTitle>
      <DialogDescription class="sr-only">{{
        $t('widget.card_instructions_modal.dialog_description')
      }}</DialogDescription>
      <div>
        <component :is="cardInstructionsComponent" v-if="cardInstructionsComponent" />
      </div>
    </DialogContent>
  </Dialog>
</template>
